module.exports = __webpack_public_path__ + "static/media/pipe.636f5330.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/pipe.svg
// module id = 3344
// module chunks = 7